export default {
	pageTitle: "Anfrage",
	subtitle: "Individuelles Angebot für Grossmengen, Serienteile und Projekte",
	intro: {
		lead: "Zu jedem berechneten Artikel erhalten Sie im Shop sofort ein automatisches Angebot. Für einzelne Teile und kleine Mengen ist das der schnellste Weg, und Sie können jederzeit direkt bestellen.",
		body: "Bei grösseren Stückzahlen und bei Teilen, die Sie immer wieder abrufen, lohnt sich der genauere Blick. Stellen Sie uns eine Anfrage: Wir prüfen sie persönlich, beraten Sie und unterbreiten Ihnen ein individuelles Angebot.",
		responseTime: "Antwort in der Regel innerhalb von 1 bis 2 Arbeitstagen",
		turnaroundValue: "1–2",
		turnaroundUnit: "Arbeitstage",
		turnaroundLabel: "bis zu Ihrem Angebot",
	},
	useCases: {
		title: "Wann sich eine Anfrage lohnt",
		bulk: {
			title: "Grossmengen",
			text: "Sie benötigen von einem Artikel eine hohe Stückzahl auf einmal.",
		},
		series: {
			title: "Serienproduktion",
			text: "Sie rufen dieselben Teile in festen Losgrössen wiederkehrend ab.",
		},
		automation: {
			title: "Roboterfertigung",
			text: "Viele Teile lassen sich bei unseren Fertigern automatisiert auf Roboteranlagen produzieren. Gerade bei Grossmengen kann das den Stückpreis deutlich senken.",
		},
		individual: {
			title: "Individuelle Anfragen",
			text: "Ihr Projekt hat besondere Anforderungen an Termine, Verpackung oder Ausführung.",
		},
	},
	requirement: {
		title: "Voraussetzung: Die Artikel sind bereits bei Blexon",
		text: "Wir können nur Artikel kalkulieren, die Sie hochgeladen haben und die berechnet und bestellbar sind. Für Einzelteile und kleine Mengen bleibt das automatische Angebot im Warenkorb die schnellere Wahl.",
		linkLabel: "Zu meinen Artikeln",
	},
	steps: {
		title: "So läuft es ab",
		step1: {
			title: "Warenkorb zusammenstellen",
			text: "Wählen Sie die Artikel aus und erfassen Sie die Mengen, die Sie einmalig oder wiederkehrend bestellen möchten.",
		},
		step2: {
			title: "Details zur Anfrage angeben",
			text: "Ergänzen Sie, ob Sie einmalig oder wiederkehrend abrufen, dazu Wunschtermine und alles, was wir sonst wissen sollten.",
		},
		step3: {
			title: "Angebot erhalten",
			text: "Wir prüfen Ihre Anfrage persönlich und melden uns innerhalb von 1 bis 2 Arbeitstagen.",
		},
	},
	list: {
		title: "Ihre Anfragen",
		loading: "Anfragen werden geladen …",
		loadFailed: "Ihre Anfragen konnten nicht geladen werden.",
	},
	empty: {
		title: "Noch keine Anfrage erstellt",
		text: "Stellen Sie Ihre erste Anfrage für Grossmengen, Serienteile oder ein Projekt. Wir schauen sie uns persönlich an.",
		cartSummary: "Ihr Warenkorb enthält {count} Artikel.",
		emptyCartTitle: "Stellen Sie zuerst Ihren Warenkorb zusammen",
		emptyCartText:
			"Eine Anfrage geht immer von Ihrem Warenkorb aus. Legen Sie die Artikel mit den gewünschten Mengen hinein. Danach stellen Sie die Anfrage direkt von hier aus.",
		emptyCartButton: "Zu meinen Artikeln",
	},
	createButton: "Anfrage mit aktuellem Warenkorb erstellen",
	createButtonShort: "Neue Anfrage",
	tile: {
		requestNumber: "Anfrage {number}",
		untitled: "Ohne Bezeichnung",
		articleCount: "Artikel",
		totalQuantity: "Stück gesamt",
		recurring: "Wiederkehrender Abruf",
		createdAt: "Erstellt am {date}",
		edit: "Anfrage bearbeiten",
		view: "Anfrage ansehen",
		viewOffer: "Angebot ansehen",
		delete: "Entwurf löschen",
	},
	states: {
		draft: "Entwurf",
		waitingForManualOffer: "In Prüfung",
		waitingForCustomerAnswer: "Angebot bereit",
		waitingForInspectionParts: "Warten auf Erstmuster",
		accepted: "Angenommen",
		declined: "Abgelehnt",
		unknown: "Unbekannt",
	},
	form: {
		pageTitle: "Neue Anfrage",
		editTitle: "Anfrage bearbeiten",
		viewTitle: "Anfrage",
		readonlyNote:
			"Sie haben diese Anfrage abgeschickt. Sie können sie weiterhin ansehen, aber nicht mehr ändern.",
		loadFailed: "Die Anfrage konnte nicht geladen werden.",
		draftHint: "Änderungen werden automatisch als Entwurf gespeichert.",
		draftSaving: "Entwurf wird gespeichert …",
		draftSaved: "Entwurf gespeichert um {time}",
		draftSaveFailed: "Entwurf konnte nicht gespeichert werden.",
		subtitle: "Sagen Sie uns, worum es geht. Wir prüfen Ihre Anfrage persönlich.",
		title: {
			title: "Bezeichnung",
			hint: "Optional. Hilft Ihnen, die Anfrage später wiederzuerkennen.",
			placeholder: "Zum Beispiel Konsolen Baureihe M",
		},
		positions: {
			title: "Artikel und Mengen",
			summary:
				"{count} Position, {quantity} Stück gesamt | {count} Positionen, {quantity} Stück gesamt",
			copiedHint:
				"Die Artikel stammen aus Ihrem Warenkorb. Sie können hier Mengen ändern, Positionen entfernen und weitere Artikel hinzufügen, ohne Ihren Warenkorb zu verändern.",
			empty: "Diese Anfrage enthält noch keine Artikel.",
			articleNumber: "Art.-Nr. {id}",
			summaryShort: "{quantity} Stück in der Anfrage",
			quantityLabel: "Menge",
			articleHeader: "Artikel",
			selectAll: "Alle auswählen",
			remove: "Position entfernen",
			add: "Artikel hinzufügen",
			show: "Einblenden",
			hide: "Ausblenden",
		},
		picker: {
			title: "Artikel hinzufügen",
			search: "Artikel suchen",
			loading: "Artikel werden gesucht …",
			empty: "Keine weiteren bestellbaren Artikel gefunden.",
			addTooltip: "Artikel zur Anfrage hinzufügen",
			close: "Schliessen",
		},
		orderType: {
			title: "Art der Bestellung",
			oneTime: "Einmalige Bestellung",
			oneTimeHint: "Sie benötigen diese Menge einmalig.",
			recurring: "Wiederkehrende Serie",
			recurringHint: "Sie rufen dieselben Teile mehrfach ab.",
			completionTitle: "In welchem Zeitraum soll der Auftrag fertig sein?",
			completionTitleFirstDelivery:
				"In welchem Zeitraum soll die erste Fertigstellung erfolgen?",
			completionFrom: "Fertigstellung von",
			completionTo: "Fertigstellung bis",
			callOffTitle: "Der obige Bedarf entsteht",
			callOffWeekly: "Wöchentlich",
			callOffMonthly: "Monatlich",
			callOffYearly: "Jährlich",
			callOffEveryWeek: "Jede Woche",
			callOffEveryNWeeks: "Alle paar Wochen",
			callOffEveryMonth: "Jeden Monat",
			callOffEveryNMonths: "Alle paar Monate",
			callOffEveryPrefix: "Alle",
			callOffWeeksUnit: "Wochen",
			callOffMonthsUnit: "Monate",
			callOffCountMin: "Mindestens 2.",
			callOffDeliveriesTitle: "Anzahl Abrufe",
			callOffUntilRevoked: "Bis auf Widerruf",
			callOffLimited: "Eine bestimmte Anzahl Abrufe",
			callOffDeliveriesUnit: "Abrufe",
			callOffLastDelivery: "Letzte Fertigstellung: {date}",
			seriesNotice:
				"Sie erhalten ein Angebot für die erste Serie und einen Richtpreis für die folgenden Serien. Für die Folgeserien wird ein Teuerungsindex berücksichtigt.",
		},
		delivery: {
			title: "Lieferung oder Abholung",
			pickup: "Abholung",
			pickupHint: "Sie holen den Auftrag selbst ab.",
			delivery: "Lieferung",
			deliveryHint: "Wir liefern an eine Ihrer Adressen.",
			addressLabel: "Ort der Lieferung",
			noAddresses: "Für Ihr Konto ist noch keine Lieferadresse hinterlegt.",
			noteLabelDelivery: "Hinweise zur Lieferung",
			noteHint: "Zum Beispiel Teillieferungen, Anlieferzeiten oder Verpackung.",
		},
		inspection: {
			title: "Erstmuster",
			explanation:
				"Bei grösseren Mengen empfehlen wir Erstmuster. Die Kosten werden im Preis des Angebots ausgewiesen.",
			wanted: "Erstmuster gewünscht",
			notWanted: "Keine Erstmuster",
			scopeTitle: "Welche Positionen sollen bemustert werden?",
			allPositions: "Alle Positionen",
			selectedPositions: "Nur ausgewählte Positionen",
			selectHint:
				"Haken Sie die gewünschten Positionen an und geben Sie je Position die Menge für die Erstmuster an.",
			columnHeader: "Erstmuster",
			quantityLabel: "Menge",
			quantityTooHigh: "Höchstens {max} Stück.",
			noPositions: "Fügen Sie zuerst Artikel hinzu.",
		},
		remarks: {
			title: "Bemerkungen",
			hint: "Alles, was für die Kalkulation wichtig ist.",
		},
		submit: "Unverbindliche Anfrage senden",
		cancel: "Schliessen",
		delete: "Anfrage löschen",
		deleteConfirmTitle: "Anfrage löschen?",
		deleteConfirmText:
			"Die Anfrage wird mit allen Positionen gelöscht. Das lässt sich nicht rückgängig machen.",
		deleteConfirm: "Endgültig löschen",
		deleteCancel: "Behalten",
		deleted: "Die Anfrage wurde gelöscht.",
		deleteFailed: "Die Anfrage konnte nicht gelöscht werden.",
		blockers: {
			positions: "Fügen Sie mindestens einen Artikel hinzu.",
			completionWindow: "Geben Sie an, in welchem Zeitraum der Auftrag fertig sein soll.",
			completionOrder: "Das Datum für die späteste Fertigstellung liegt vor dem frühesten.",
			callOffIntervalCount:
				"Geben Sie an, alle wie viele Wochen oder Monate der Bedarf entsteht.",
			callOffCount: "Geben Sie an, wie viele Abrufe Sie wünschen. Mindestens 2.",
			address: "Wählen Sie den Ort der Lieferung.",
			inspectionPositions: "Wählen Sie mindestens eine Position für die Erstmuster aus.",
			inspectionQuantity: "Geben Sie für jede bemusterte Position eine gültige Menge an.",
		},
		submitted:
			"Ihre Anfrage ist bei uns eingegangen. Wir melden uns innerhalb von 1 bis 2 Arbeitstagen.",
		submitFailed: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
	},
};
